import { type IHydratedWidget } from '../../../../../hydrate/IHydrationContext.ts';
import { generateMarginStyle } from '../../../../directives/margin/generateMarginStyle.ts';
import { type IHtmlRenderContext } from '../../../IWidgetType.ts';
import { type IColumnWidget } from './IColumnWidget.ts';

export function renderColumnHtml(
  widget: IHydratedWidget<IColumnWidget>,
  context: IHtmlRenderContext,
): string {
  const childrenHtml = context.renderChildren(widget.children ?? []);
  const marginStyle = generateMarginStyle(widget.directives?.margin);
  const columnStyle = marginStyle ? ` style="${marginStyle}"` : '';

  return `<div${columnStyle}>${childrenHtml}</div>`;
}
